/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Company controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetCompanyByIdResponse, UpdateCompanyRequest, CustomerState, GetCompaniesResponse, CreateCompanyRequest, CreateCompanyResponse } from "../models";

@Injectable({ providedIn: "root" })
export class CompanyService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getCompanyById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCompanyByIdResponse>;
    getCompanyById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCompanyByIdResponse>>;
    getCompanyById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCompanyByIdResponse>>;
    getCompanyById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Company/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateCompany(id: number, requestBody: UpdateCompanyRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateCompany(id: number, requestBody: UpdateCompanyRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateCompany(id: number, requestBody: UpdateCompanyRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateCompany(id: number, requestBody: UpdateCompanyRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Company/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, requestBody, requestOptions);
    }

    deleteCompany(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteCompany(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteCompany(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteCompany(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Company/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getCompanies(searchTerm?: string | null, states?: (Array<CustomerState> | null), observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCompaniesResponse>;
    getCompanies(searchTerm?: string | null, states?: (Array<CustomerState> | null), observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCompaniesResponse>>;
    getCompanies(searchTerm?: string | null, states?: (Array<CustomerState> | null), observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCompaniesResponse>>;
    getCompanies(searchTerm?: string | null, states?: (Array<CustomerState> | null), observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Company`;

        let params = new HttpParams();
        if (searchTerm != null) {
            params = HttpParamsBuilder.addToHttpParams(params, searchTerm, 'searchTerm');
        }
        if (states != null) {
            params = HttpParamsBuilder.addToHttpParams(params, states, 'states');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createCompany(requestBody: CreateCompanyRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateCompanyResponse>;
    createCompany(requestBody: CreateCompanyRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateCompanyResponse>>;
    createCompany(requestBody: CreateCompanyRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateCompanyResponse>>;
    createCompany(requestBody: CreateCompanyRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Company`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, requestBody, requestOptions);
    }
}
